import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

import { ReactComponent as FinanceIcon } from "../../Global/icons/Finance-Administrative.svg";
import { ReactComponent as EngenieringIcon } from "../../Global/icons/Engineering-Logistic.svg";
import { ReactComponent as CommercialMktgIcon } from "../../Global/icons/Commercial-Marketing.svg";
import { ReactComponent as ItTelcoIcon } from "../../Global/icons/IT-Telco.svg";

import EngineeringLogistiticImage from "../../Global/images/Engineering-e-Logistic.png";
import FinanceAdministrative from "../../Global/images/Finance-e-Administrative.png";
import CommercialMarketing from "../../Global/images/Commercial-e-Marketing.png";
import ItTelco from "../../Global/images/IT-e-Telco.png";

const StyledAreasOfSpecialization = styled(NanoFlex)`
  padding: 0 100px 0 100px;
  gap: 30px;

  .blockTitle {
    width: 40%;
    height: auto;
    gap: 24px;

    @media only screen and (max-width: 1024px) {
      gap: 16px;
    }

    h3 {
      font-weight: 500;
    }
  }

  .specializationBlocks {
    width: 60%;
    gap: 30px;
    height: auto;

    .specializationItem {
      min-height: 150px;
      height: auto;
      border-radius: 10px;
      background-color: ${(props) => props.theme.color.primaryColors.lighterPurple};
      padding: 32px;
      gap: 24px;

      .specializationItemHeader {
        position: relative;

        svg {
          height: 5vh;
          width: auto;
        }

        .hoverImageDot {
          flex-grow: 1;

          .purpleDot {
            width: 13px;
            height: 13px;
            background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
            border-radius: 100%;
            animation: blink 1s ease-in-out;
            animation-iteration-count: infinite;

            &:hover ~ .hiddenImageContainer {
              display: flex;
            }

            @keyframes blink {
              0% {
                box-shadow: 0 0 0 0 rgb(173 135 214 / 55%);
              }
              100% {
                box-shadow: 0 0 0 8px transparent;
              }
            }
          }

          .hiddenImageContainer {
            position: absolute;
            right: 8px;
            top: 8px;
            width: 50vw;
            height: auto;
            border-radius: 10px;
            display: none;
            overflow: hidden;
            border-radius: 10px;
            z-index: 2;

            img {
              min-height: 100%;
              min-width: 100%;
              height: auto;
              width: auto;
            }
          }
        }
      }

      .specializationItemContent {
        gap: 16px;
        h4 {
          font-weight: 500;
        }
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0 50px 0 50px;
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0 30px 0 30px;
  }

  @media only screen and (max-width: 815px) {
    padding: 0 10px 0 10px;
    flex-wrap: wrap;
    gap: 24px;

    .blockTitle {
      width: 100%;
    }

    .specializationBlocks {
      flex-wrap: wrap;
      flex-direction: row;
      width: 100%;
      gap: 16px;
      .specializationItem {
        width: calc(50% - 16px);
        flex: 1 calc(50% - 16px);
        gap: 16px;
        padding: 16px;
        min-height: 216px;
        border-radius: 5px;

        .specializationItemHeader {
          .hoverImageDot {
            .purpleDot {
              &:hover ~ .hiddenImageContainer {
                right: 0;
                top: 14px;
                width: 100%;
              }
            }
          }
        }

        .specializationItemContent {
          flex-grow: 1;
          justify-content: space-between;
        }
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    .specializationBlocks {
      flex-direction: column;
      flex-wrap: nowrap;
      .specializationItem {
        width: 100%;
        flex: 1 100%;
        min-height: unset;

        .specializationItemContent {
          flex-grow: 0;
          justify-content: center;
        }
      }
    }
  }
`;

export default class AreasOfSpecialization extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAreasOfSpecialization justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="blockTitle" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <Type.h3>{this.translation.aboutUs.specializationAreas}</Type.h3>
          <Type.p>{this.translation.aboutUs.specializationAreasSubtitle}</Type.p>
        </NanoFlex>
        <NanoFlex className="specializationBlocks" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="specializationItem" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="specializationItemHeader" alignItems="flex-start">
              <NanoFlex className="iconWrapper" justifyContent="flex-start">
                <FinanceIcon />
              </NanoFlex>
              <NanoFlex className="hoverImageDot" justifyContent="flex-end" alignItems="flex-start">
                <NanoFlex className="purpleDot"></NanoFlex>

                <NanoFlex className="hiddenImageContainer">
                  <img src={FinanceAdministrative} alt={this.translation.homepage.consultantsBlock.financeAdministrative} />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="specializationItemContent" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
              <Type.h4>{this.translation.homepage.consultantsBlock.financeAdministrative}</Type.h4>
              <Type.p>{this.translation.aboutUs.financeAdministrativeText}</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="specializationItem" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="specializationItemHeader" alignItems="flex-start">
              <NanoFlex className="iconWrapper" justifyContent="flex-start">
                <EngenieringIcon />
              </NanoFlex>
              <NanoFlex className="hoverImageDot" justifyContent="flex-end" alignItems="flex-start">
                <NanoFlex className="purpleDot"></NanoFlex>

                <NanoFlex className="hiddenImageContainer">
                  <img src={EngineeringLogistiticImage} alt={this.translation.homepage.consultantsBlock.financeAdministrative} />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="specializationItemContent" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
              <Type.h4>{this.translation.homepage.consultantsBlock.engineeringLogistics}</Type.h4>
              <Type.p>{this.translation.aboutUs.engeneeringLogisticsText}</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="specializationItem" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="specializationItemHeader" alignItems="flex-start">
              <NanoFlex className="iconWrapper" justifyContent="flex-start">
                <CommercialMktgIcon />
              </NanoFlex>
              <NanoFlex className="hoverImageDot" justifyContent="flex-end" alignItems="flex-start">
                <NanoFlex className="purpleDot"></NanoFlex>

                <NanoFlex className="hiddenImageContainer">
                  <img src={CommercialMarketing} alt={this.translation.homepage.consultantsBlock.financeAdministrative} />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="specializationItemContent" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
              <Type.h4>{this.translation.homepage.consultantsBlock.commercialMarketing}</Type.h4>
              <Type.p>{this.translation.aboutUs.commercialMarketingText}</Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="specializationItem" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="specializationItemHeader" alignItems="flex-start">
              <NanoFlex className="iconWrapper" justifyContent="flex-start">
                <ItTelcoIcon />
              </NanoFlex>
              <NanoFlex className="hoverImageDot" justifyContent="flex-end" alignItems="flex-start">
                <NanoFlex className="purpleDot"></NanoFlex>
                <NanoFlex className="hiddenImageContainer">
                  <img src={ItTelco} alt={this.translation.homepage.consultantsBlock.financeAdministrative} />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="specializationItemContent" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
              <Type.h4>{this.translation.homepage.consultantsBlock.itTelco}</Type.h4>
              <Type.p>{this.translation.aboutUs.itTelcoText}</Type.p>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledAreasOfSpecialization>
    );
  }
}
